var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenSubCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7857 0H3.21427C1.43995 0.00210937 0.00210937 1.43995 0 3.21427V14.7857C0.00210937 16.56 1.43995 17.9979 3.21427 18H14.7857C16.56 17.9979 17.9979 16.56 18 14.7857V3.21427C17.9979 1.43995 16.56 0.00210937 14.7857 0ZM16.7143 14.7857C16.7143 15.8508 15.8508 16.7143 14.7857 16.7143H3.21427C2.14915 16.7143 1.2857 15.8508 1.2857 14.7857V3.21427C1.2857 2.14915 2.14915 1.2857 3.21427 1.2857H14.7857C15.8508 1.2857 16.7143 2.14915 16.7143 3.21427V14.7857Z",
    fill: "#67833E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2143 8.35715H9.64285V5.78571C9.64285 5.43066 9.35503 5.14285 8.99998 5.14285C8.64493 5.14285 8.35711 5.43066 8.35711 5.78571V8.35715H5.78571C5.43066 8.35715 5.14284 8.64497 5.14284 9.00002C5.14284 9.35508 5.43066 9.64285 5.78571 9.64285H8.35715V12.2143C8.35715 12.5693 8.64497 12.8572 9.00002 12.8572C9.35507 12.8572 9.64285 12.5693 9.64285 12.2143V9.64285H12.2143C12.5693 9.64285 12.8572 9.35504 12.8572 8.99999C12.8572 8.64493 12.5693 8.35715 12.2143 8.35715Z",
    fill: "#67833E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenSubCategory);
export default __webpack_public_path__ + "static/media/openSubCategory.05db6d6a.svg";
export { ForwardRef as ReactComponent };